export default __webpack_public_path__ + "static/technology-1a6edba8fd55a4c0f5f00f4df3582038.png";